import React from "react";
import styled, { keyframes } from "styled-components";

const bounce = keyframes`
  0%{ transform: translateY(0); }
  40% { transform: translateY(-10px); }
  80%{ transform: translateY(0); }
  100%{ transform: translateY(0); }

`;

const LoaderContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
 
`;

const BouncingDots = styled.div`
  display: flex;
  justify-content: space-between;
  width: 60px;
  padding: 10px 5px;

`;

const Dot = styled.div`
  width: 10px;
  height: 10px;
  background-color: #fff;
  border-radius: 50%;
  animation: ${bounce} 1s infinite;

  &:nth-child(1) { animation-delay: 0s; }
  &:nth-child(2) { animation-delay: 0.1s; }
  &:nth-child(3) { animation-delay: 0.2s; }
`;

const BouncingDotsLoader = () => {
  return (
    <LoaderContainer>
      <BouncingDots>
        <Dot />
        <Dot />
        <Dot />
      </BouncingDots>
    </LoaderContainer>
  );
};

export default BouncingDotsLoader;